module.exports = __webpack_public_path__ + "static/media/berezovska.5a97c415.png";